import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth';
import { AccountDetails } from '../components/account/AccountDetails';
import '../components/account/settings.css';

export default function Settings() {
  const { user, loading } = useAuth();
  const { hash } = useLocation();
  useEffect(() => {
    if (!user || !hash) return;
    const frame = requestAnimationFrame(() => {
      const section = document.getElementById(hash.slice(1));
      section?.scrollIntoView({ block: 'start' });
      if (hash === '#settings-password-section') section?.querySelector('input')?.focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(frame);
  }, [hash, user]);
  if (loading) return <p className="p-8" data-testid="settings-loading">Loading…</p>;
  if (!user) return <Navigate to="/" replace />;
  if (hash === '#privacy') return <Navigate to="/account/privacy" replace />;
  if (hash === '#connected-accounts' || hash === '#connections') return <Navigate to="/account/connections" replace />;
  if (hash === '#profile-picture') return <Navigate to="/account#profile-picture" replace />;
  if (hash === '#theme' || hash === '#color-theme') return <Navigate to="/account#color-theme" replace />;
  return <div className="settings-page" data-testid="settings-page">
      <div className="settings-content" id="account">
        <AccountDetails />
      </div>
  </div>;
}